import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseDashboardComponentsGeneratorsProps<T> = {
  filters?: {
    search?: string;
  };
  mapper?: (data: any) => T;
}

export const useDashboardComponentsGenerators = <T,>({
  filters: { search = '' } = {},
  mapper = Mapper.default<T>(),
}: UseDashboardComponentsGeneratorsProps<T>) => {
  const privateAxios = usePrivateAxios();

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['dashboardComponentsGenerators', search],
    queryFn: () => {
      return privateAxios.get(`/dashboard_components/generators`, {
        params: {
          search,
        }
      });
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
    staleTime: 60000,
  });

  return { data, meta, ...rest };
}
